<template>

  <b
    :class="`text-${status.style}`">
    {{ status.text }}
  </b>

</template>

<script>
export default {
  name: 'ValueCustomField',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    status () {
      const options = {
        'pending': { text: 'Pendente', style: 'warning' },
        'paid': { text: 'Paga', style: 'success' },
        'canceled': { text: 'Cancelada', style: 'danger' },
        'in_analysis': { text: 'Em análise', style: 'warning' },
        'draft': { text: 'Rascunho', style: 'secondary' },
        'partially_paid': { text: 'Parcialmente paga', style: 'warning' },
        'refunded': { text: 'Reembolsada', style: 'dark' },
        'expired': { text: 'Expirada', style: 'darger' },
        'in_protest': { text: 'Em protesto', style: 'darger' },
        'chargeback': { text: 'Contestada', style: 'darger' },
        'externally_paid': { text: 'Paga externamente', style: 'info' }
      }
      return options[this.value] || { text: this.value, style: 'info' }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/InvoiceStatus.vue